import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = { style: {"border-radius":"10px","position":"relative","padding":"20px","border-top":"0","color":"#666"} }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-right":"10px","font-size":"16px","color":"#666666","width":"135px"} }, "报告编号/验证码:", -1)
const _hoisted_5 = { style: {"flex":"1"} }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-right":"10px","font-size":"16px","color":"#666666","width":"135px"} }, "查询指定名称:", -1)
const _hoisted_8 = { style: {"flex":"1"} }
const _hoisted_9 = {
  key: 0,
  style: {"width":"100%","height":"80px"}
}
const _hoisted_10 = {
  key: 1,
  style: {"color":"#ff6622","padding":"30px 0","text-align":"left","height":"80px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "您输入的编号有误，查询的报告不存在", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  style: {"color":"#666666","padding":"20px 0","text-align":"left","line-height":"28px","height":"80px"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 查询结果：报告编号")
const _hoisted_15 = { style: {"color":"#ff6622"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("， 检测项目")
const _hoisted_17 = { style: {"color":"#ff6622"} }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("， 检测结果")
const _hoisted_19 = {
  key: 0,
  style: {"color":"#22aa22"}
}
const _hoisted_20 = {
  key: 1,
  style: {"color":"#cc2222"}
}
const _hoisted_21 = { style: {"width":"100%"} }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_input_view = _resolveComponent("input-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_input_view, {
            modelValue: $data.code,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.code) = $event)),
            class: "form-control",
            placeholder: "请输入报告编号或查询验证码"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_input_view, {
            modelValue: $data.code1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.code1) = $event)),
            class: "form-control",
            placeholder: "请输入公司名称、产品名称、或项目名称"
          }, null, 8, ["modelValue"])
        ])
      ]),
      (!$data.showError&&!$data.showInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
        : _createCommentVNode("", true),
      ($data.showError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
        : _createCommentVNode("", true),
      ($data.showInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, "【" + _toDisplayString($data.data.code) + "】", 1),
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, "【" + _toDisplayString($data.data.testProjectName||'-') + "】", 1),
            _hoisted_18,
            ($data.data.testResult==1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "【符合】"))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, "【不符合】"))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("input", {
          class: "btn btn-primary btn-block btn-flat",
          style: {"height":"44px","border-radius":"5px","background":"#002e5b"},
          type: "submit",
          value: "查询",
          onClick: _cache[2] || (_cache[2] = (...args) => ($options.searchEvent && $options.searchEvent(...args)))
        })
      ])
    ])
  ]))
}